import { UserBookingInterest } from "src/models/BookingInterest";

export const validationBookingInterestsFilter = (
  relatedInterest: UserBookingInterest
): boolean => {
  return (
    (relatedInterest.status === "TicketAccepted" ||
    relatedInterest.status === "AttendanceConfirmedViaSMS" ||
    relatedInterest.status === "AttendanceSMSReminderSent" ||
    relatedInterest.status === "InvitedToTicket") &&
    relatedInterest.isDependent === true
  );
};

export const copyToClipboard = ((text: string) => {
  navigator.clipboard.writeText(text);
});

export const handleAutoScrolling = (id: string) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }
};